import { IEditorV3 } from "../classes/interface";

/**
 * Extracts plain text content from EditorV3 content structure.
 * Returns an array of strings where each element represents the text content of a line.
 *
 * @param input - The EditorV3 content to extract text from
 * @returns Array of strings, one per line of content, or [""] if input is empty or null
 */
export const getTextFromEditorV3 = (input?: IEditorV3 | null): string[] =>
  input && input.lines.length > 0
    ? input.lines.map((l) => l.textBlocks.map((tb) => tb.text).join(""))
    : [""];
